module.exports = __webpack_public_path__ + "img/kindred.f89f140f.png";